<template>
  <v-container>
    <v-dialog v-model="dialog" width="1000">
      <v-card>
        <v-card-text>
          <img
            :src="photoUrl"
            @error="handleImageError"
            class="image-preview"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-layout row wrap class="text-xs-center">
      <v-flex xs4 sm3>
        <ProfileSidebar active="general" />
      </v-flex>
      <v-flex xs7 sm8 offset-xs1>
        <v-form lazy-validation>
          <div>
            <v-avatar size="160" class="pro-pic">
              <img
                :src="photoUrl"
                @error="handleImageError"
                alt="Profile Picture"
              />
              <div class="overlay"></div>

              <div class="pro-pic-icon" v-if="photoUrl">
                <v-icon title="View" @click="dialog = true">visibility</v-icon>
              </div>
              <div class="pro-pic-icon edit-icon">
                <v-icon title="Change" @click="$refs.fileInput.click()">
                  edit
                </v-icon>
              </div>
            </v-avatar>
            <h3 class="mt-1">{{ userRole && JSON.parse(userRole).name }}</h3>
            <v-progress-linear
              v-if="uploading"
              :indeterminate="true"
              style="width: 100px; margin: 15px auto 0"
              error
            ></v-progress-linear>

            <input
              type="file"
              ref="fileInput"
              style="display: none"
              @change="handleFileUpload"
              accept="image/*"
            />
          </div>
        </v-form>
        <br />
        <v-card class="pa-3">
          <v-form ref="form" v-model="valid">
            <h2 class="align-left">Basic Information</h2>
            <v-layout>
              <v-flex sm6 class="mr-2">
                <v-text-field
                  v-model="name"
                  :rules="[(v) => !!v || 'Name is required']"
                  label="Name*"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex sm6 class="ml-2">
                <v-text-field
                  v-model="email"
                  :rules="emailRules"
                  label="Email*"
                  readonly
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex sm6 class="mr-2">
                <v-text-field
                  v-model="companyName"
                  :rules="[(v) => !!v || 'Company Name is required']"
                  label="Company Name*"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex sm6 class="ml-2">
                <v-text-field
                  v-model="phone"
                  :rules="phoneRules"
                  label="Phone*"
                  required
                ></v-text-field>
              </v-flex>
            </v-layout>
            <!-- <v-textarea
            rows="2"
            v-model="address"
            :rules="[(v) => !!v || 'Address is required']"
            label="Address*"
            required
          ></v-textarea>

          <v-textarea
            rows="2"
            v-model="billingAddress"
            :rules="[(v) => !!v || 'Billing Address is required']"
            label="Billing Address*"
            required
            :readonly="sameAsAbove"
          ></v-textarea> -->
            <!-- <v-layout row wrap>
            <v-flex xs1>
              <v-checkbox @change="makeSameAsAbove" class="mx-0 mt-1" />
            </v-flex>
            <v-flex xs11 text-xs-left class="mt-2">
              <p>Same as Above</p>
            </v-flex>
          </v-layout> -->

            <!-- <div class="align-left ml5">
              <v-btn
                :disabled="!valid"
                color="primary"
                :loading="loading"
                @click="updateProfileInfo"
              >
                Update
              </v-btn>
            </div> -->
            <!-- </v-form>
        </v-card> -->
            <!-- <br /> -->
            <!-- <v-card class="pa-3">
          <v-form ref="addressForm" v-model="addressValid" v-if="divDistUpz"> -->
            <h2 class="align-left">Address</h2>
            <v-layout>
              <v-flex sm6 class="mr-2">
                <v-autocomplete
                  v-model="division"
                  :items="divDistUpz.divisions"
                  :loading="!divDistUpz"
                  item-text="english_title"
                  item-value="id"
                  :rules="[(v) => !!v || 'Division is required']"
                  label="Division *"
                  required
                ></v-autocomplete>
              </v-flex>
              <v-flex sm6 class="ml-2">
                <v-autocomplete
                  v-model="district"
                  :items="getDistrictList(division)"
                  :loading="!divDistUpz"
                  item-text="english_title"
                  item-value="id"
                  :rules="[(v) => !!v || 'District is required']"
                  label="District *"
                  required
                ></v-autocomplete>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex sm6 class="mr-2">
                <v-autocomplete
                  v-model="upazila"
                  :items="getUpazilaList(district)"
                  :loading="!divDistUpz"
                  item-text="english_title"
                  item-value="id"
                  :rules="[(v) => !!v || 'Upazila is required']"
                  label="Upazila *"
                  required
                ></v-autocomplete>
              </v-flex>
              <v-flex sm6 class="ml-2">
                <v-text-field
                  v-model="postCode"
                  :rules="[(v) => !!v || 'Post Code is required']"
                  label="Post Code*"
                  required
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-text-field
              v-model="address"
              :rules="[(v) => !!v || 'Address is required']"
              label="Address*"
              required
            ></v-text-field>

            <!-- <div class="align-left ml5">
              <v-btn
                :disabled="!addressValid"
                color="primary"
                :loading="addressLoading"
                @click="updateAddress"
              >
                Update
              </v-btn>
            </div>
          </v-form>
        </v-card> -->
            <!-- <br /> -->
            <!-- <v-card class="pa-3">
          <v-form
            ref="billingAddressForm"
            v-model="billingAddressValid"
            v-if="divDistUpz"
          > -->
            <h2 class="align-left">Billing Address</h2>
            <v-layout row wrap>
              <v-flex xs1>
                <v-checkbox @change="makeSameAsAbove" class="mx-0 mt-1" />
              </v-flex>
              <v-flex xs11 text-xs-left class="mt-2">
                <p>Same as Address</p>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex sm6 class="mr-2">
                <v-autocomplete
                  v-model="billingDivision"
                  :items="divDistUpz.divisions"
                  :loading="!divDistUpz"
                  item-text="english_title"
                  item-value="id"
                  :rules="[(v) => !!v || 'Division is required']"
                  label="Division *"
                  required
                  :readonly="sameAsAbove"
                ></v-autocomplete>
              </v-flex>
              <v-flex sm6 class="ml-2">
                <v-autocomplete
                  v-model="billingDistrict"
                  :items="getDistrictList(billingDivision)"
                  :loading="!divDistUpz"
                  item-text="english_title"
                  item-value="id"
                  :rules="[(v) => !!v || 'District is required']"
                  label="District *"
                  required
                  :readonly="sameAsAbove"
                ></v-autocomplete>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex sm6 class="mr-2">
                <v-autocomplete
                  v-model="billingUpazila"
                  :items="getUpazilaList(billingDistrict)"
                  :loading="!divDistUpz"
                  item-text="english_title"
                  item-value="id"
                  :rules="[(v) => !!v || 'Upazila is required']"
                  label="Upazila *"
                  required
                  :readonly="sameAsAbove"
                ></v-autocomplete>
              </v-flex>
              <v-flex sm6 class="ml-2">
                <v-text-field
                  v-model="billingPostCode"
                  :rules="[(v) => !!v || 'Post Code is required']"
                  label="Post Code*"
                  required
                  :readonly="sameAsAbove"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-text-field
              v-model="billingAddress"
              :rules="[(v) => !!v || 'Address is required']"
              label="Address*"
              required
              :readonly="sameAsAbove"
            ></v-text-field>
            <div class="align-left ml5">
              <v-btn
                round
                :disabled="!valid"
                color="primary"
                :loading="loading"
                @click="updateProfileInfo"
              >
                Update
              </v-btn>
            </div>
            <!-- <div class="align-left ml5">
              <v-btn
                :disabled="!billingAddressValid"
                color="primary"
                :loading="billingAddressLoading"
                @click="updateBillingAddress"
              >
                Update
              </v-btn>
            </div>-->
          </v-form>
        </v-card>
        <v-snackbar v-model="snackbar" :color="color" bottom right>
          {{ msg }}
        </v-snackbar>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
  import ProfileSidebar from "../../components/profile/ProfileSidebar.vue";
  import api from "../../api/datadash";
  import { mapState } from "vuex";
  import axios from "axios";
  import { ROOT_URL } from "../../api/connectingUrls";

  export default {
    components: {
      ProfileSidebar,
    },
    data: () => ({
      valid: false,
      // addressValid: true,
      // billingAddressValid: true,
      name: "",
      email: "",
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+/.test(v) || "E-mail must be valid",
      ],
      phone: "",
      phoneRules: [
        (v) => !!v || "Phone Number is required",
        (v) =>
          /^01{1}[3-9]{1}\d{8}$/.test(v) ||
          "Phone Number must be valid Bangladeshi mobile number",
      ],
      address: "",
      billingAddress: "",
      sameAsAbove: false,
      companyName: "",
      photoUrl: "",
      fallBackImage:
        "https://cdn.pixabay.com/photo/2015/03/04/22/35/avatar-659651_1280.png",
      loading: false,
      // addressLoading: false,
      // billingAddressLoading: false,
      apiUrl: "profile-info",
      snackbar: false,
      color: "success",
      msg: "Updated successfully",
      dialog: false,
      uploading: false,
      userRole: localStorage.getItem("user_role"),
      divDistUpz: "",
      division: null,
      district: null,
      upazila: "",
      postCode: "",
      billingDivision: null,
      billingDistrict: null,
      billingUpazila: "",
      billingPostCode: "",
    }),
    computed: {
      ...mapState(["auth"]),
    },
    watch: {
      division() {
        if (this.sameAsAbove) {
          this.billingDivision = this.division;
        }
      },
      district() {
        if (this.sameAsAbove) {
          this.billingDistrict = this.district;
        }
      },
      upazila() {
        if (this.sameAsAbove) {
          this.billingUpazila = this.upazila;
        }
      },
      postCode() {
        if (this.sameAsAbove) {
          this.billingPostCode = this.postCode;
        }
      },
      address() {
        if (this.sameAsAbove) {
          this.billingAddress = this.address;
        }
      },
    },
    async mounted() {
      this.getProfileInfo();
      await this.getDivDistUpz();
      this.getAddress();
      this.getBillingAddress();
    },

    methods: {
      async getDivDistUpz() {
        try {
          const { data } = await api.fetchData(this.auth.token, "div-dist-upz");
          if (!data.error) {
            this.divDistUpz = data.data;
          }
        } catch (e) {
          //
        }
      },

      async getProfileInfo() {
        try {
          const { data } = await api.fetchData(this.auth.token, this.apiUrl);
          this.name = data.data.profileData.name;
          this.email = data.data.profileData.email;
          this.companyName = data.data.profileData.client.name;
          this.phone = data.data.profileData.client.phone;
          // this.address = data.data.profileData.client.address;
          // this.billingAddress = data.data.profileData.client.billing_address;
          this.photoUrl = data.data.photo_url + data.data.profileData.photo;
        } catch (e) {
          //
        }
      },

      async getAddress() {
        try {
          const { data } = await api.fetchData(
            this.auth.token,
            "client-address"
          );
          if (data.data) {
            this.division = data.data.clientAddress.division_id;
            this.district = data.data.clientAddress.district_id;
            this.upazila = data.data.clientAddress.upazila_id;
            this.postCode = data.data.clientAddress.post_code;
            this.address = data.data.clientAddress.address;
          }
        } catch (e) {
          //
        }
      },

      async getBillingAddress() {
        try {
          const { data } = await api.fetchData(
            this.auth.token,
            "billing-address"
          );
          if (data.data) {
            this.billingDivision = data.data.billingAddress.division_id;
            this.billingDistrict = data.data.billingAddress.district_id;
            this.billingUpazila = data.data.billingAddress.upazila_id;
            this.billingPostCode = data.data.billingAddress.post_code;
            this.billingAddress = data.data.billingAddress.address;
          }
        } catch (e) {
          //
        }
      },

      async updateProfileInfo() {
        if (this.$refs.form.validate()) {
          this.loading = true;
          try {
            const { data } = await api.storeData(this.auth.token, this.apiUrl, {
              name: this.name,
              company_name: this.companyName,
              phone: this.phone,
              address: {
                division_id: this.division,
                district_id: this.district,
                upazila_id: this.upazila,
                post_code: this.postCode,
                address: this.address,
              },
              billing_address: {
                division_id: this.billingDivision,
                district_id: this.billingDistrict,
                upazila_id: this.billingUpazila,
                post_code: this.billingPostCode,
                address: this.billingAddress,
              },
            });
            if (data.error) {
              this.color = "error";
              this.msg = "Profile Information Update failed";
            } else {
              this.color = "success";
              this.msg = "Profile Information Updated successfully";
            }
            this.snackbar = true;
            this.loading = false;
          } catch (e) {
            // console.log(e);
          }
        }
      },

      // async updateAddress() {
      //   if (this.$refs.addressForm.validate()) {
      //     this.addressLoading = true;
      //     try {
      //       const { data } = await api.storeData(
      //         this.auth.token,
      //         "client-address",
      //         {
      //           division_id: this.division,
      //           district_id: this.district,
      //           upazila_id: this.upazila,
      //           post_code: this.postCode,
      //           address: this.address,
      //         }
      //       );
      //       if (data.error) {
      //         this.color = "error";
      //         this.msg = "Address Update failed";
      //       } else {
      //         this.color = "success";
      //         this.msg = "Address Updated successfully";
      //       }
      //       this.snackbar = true;
      //       this.addressLoading = false;
      //     } catch (e) {
      //       // console.log(e);
      //     }
      //   }
      // },

      // async updateBillingAddress() {
      //   if (this.$refs.billingAddressForm.validate()) {
      //     this.billingAddressLoading = true;
      //     try {
      //       const { data } = await api.storeData(
      //         this.auth.token,
      //         "billing-address",
      //         {
      //           division_id: this.billingDivision,
      //           district_id: this.billingDistrict,
      //           upazila_id: this.billingUpazila,
      //           post_code: this.billingPostCode,
      //           address: this.billingAddress,
      //         }
      //       );
      //       if (data.error) {
      //         this.color = "error";
      //         this.msg = "Billing Address Update failed";
      //       } else {
      //         this.color = "success";
      //         this.msg = "Billing Address Updated successfully";
      //       }
      //       this.snackbar = true;
      //       this.billingAddressLoading = false;
      //     } catch (e) {
      //       // console.log(e);
      //     }
      //   }
      // },

      openFileInput() {
        this.$refs.fileInput.click();
      },
      async handleFileUpload(event) {
        const file = event.target.files[0];
        const formData = new FormData();
        formData.append("profile_image", file);
        this.uploading = true;
        try {
          const { data } = await axios.post(
            `${ROOT_URL}/profile-image`,
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${localStorage.getItem(
                  "datadash_token"
                )}`,
              },
            }
          );
          if (data.error) {
            this.color = "error";
            this.msg = "Profile Picture Update failed";
          } else {
            this.photoUrl = data.data.photo_url + data.data.client.photo;
            this.color = "success";
            this.msg = "Profile Picture Updated successfully";
          }
          this.snackbar = true;
          this.uploading = false;
        } catch (e) {
          // console.log(e)
        }
      },
      makeSameAsAbove() {
        this.sameAsAbove = !this.sameAsAbove;
        if (this.sameAsAbove) {
          this.billingDivision = this.division;
          this.billingDistrict = this.district;
          this.billingUpazila = this.upazila;
          this.billingPostCode = this.postCode;
          this.billingAddress = this.address;
        }
      },
      handleImageError(e) {
        e.target.src = this.fallBackImage;
      },
      getDistrictList(divisionId) {
        return this.divDistUpz.districts
          ? this.divDistUpz.districts.filter(
              (district) => district.division_id == divisionId
            )
          : [];
      },
      getUpazilaList(districtId) {
        return this.divDistUpz.upazilas
          ? this.divDistUpz.upazilas.filter(
              (upazila) => upazila.district_id == districtId
            )
          : [];
      },
    },
  };
</script>
<style scoped>
  .align-left {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-left: 0;
  }
  .ml5 {
    margin-left: -5px;
  }
  .pro-pic {
    position: relative;
  }
  .overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6);
    opacity: 0;
    transition: opacity 0.3s ease;
    width: 160px;
    height: 160px;
    border-radius: 50%;
  }

  .pro-pic:hover .overlay {
    opacity: 1;
  }
  .pro-pic .pro-pic-icon {
    position: absolute;
    z-index: 5555;
  }
  .pro-pic .edit-icon {
    top: 15px;
    right: 30px;
  }
  .pro-pic-icon i {
    cursor: pointer;
    color: #eee;
    display: none;
  }
  .pro-pic-icon i:hover {
    color: #fff;
  }
  .pro-pic:hover i {
    display: block;
  }
  .image-preview {
    max-width: 960px;
    min-width: 600px;
    display: block;
    margin: 0 auto;
  }
  hr {
    border-top: dashed 2px #bbb;
  }
</style>
